import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { FormikErrors } from "formik";
import { Col, Input, Label } from "reactstrap";
import ModalConfirm from "./ModalConfirm";
import {
  CONFIG_OPTION_TOAST_ERROR,
  CONFIG_OPTION_TOAST_NORMAL,
} from "common/toast";
import { toast } from "react-toastify";
import DatePicker from "react-datepicker";

interface PlanFeatureArrayProps {
  formik: any;
}

const PARAM_DEFAULT = {
  workplace: "",
  position: "",
  description: "",
  startDate: null,
  endDate: null,
  id: 1,
};

const TalentExperienceArray = ({ formik = "" }: PlanFeatureArrayProps) => {
  const { t } = useTranslation();
  const [isOpenConfirm, setIsOpenConfirm] = useState<boolean>(false);
  const [indexDelete, setIndexDelete] = useState<any>(null);
  const [isConfirmLoading, setIsConfirmLoading] = useState<boolean>(false);

  const onCloseConfirmClick = () => {
    setIsOpenConfirm(false);
    setIndexDelete(null);
    setIsConfirmLoading((_prev) => false);
  };

  const handleAddItem = () => {
    formik.setFieldValue("workExperiences", [
      ...formik?.values?.workExperiences,
      {
        ...PARAM_DEFAULT,
        id: formik?.values?.workExperiences?.length + 1,
        ordering: formik?.values?.workExperiences?.length + 1,
      },
    ]);
  };

  const handleRemoveItem = (index: number) => {
    const updatedItems = formik?.values?.workExperiences.filter(
      (_: any, i: any) => i !== index
    );
    formik.setFieldValue("workExperiences", updatedItems);
  };

  const handleActionDelete = async () => {
    try {
      handleRemoveItem(indexDelete);
      setIsOpenConfirm(false);
      toast(
        `${t("The process has been completed.")}`,
        CONFIG_OPTION_TOAST_NORMAL
      );
    } catch (error: any) {
      setIsConfirmLoading((_prev) => false);
      setIndexDelete(null);
      toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
    setIsConfirmLoading((_prev) => false);
  };

  // console.log(formik?.values?.workExperiences);

  return (
    <React.Fragment>
      <>
        <Col lg={12}>
          <Label htmlFor="titleKoreaInput" className="form-label">
            {t("Experiences")}
          </Label>

          <table className="w-100">
            <thead>
              <tr style={{ background: "#EDEDED", height: "37px" }}>
                <th style={{ minWidth: 25, paddingLeft: "5px" }}>{t("No.")}</th>
                <th>{t("Workplace")}</th>
                <th>{t("Position")}</th>
                <th>{t("Start Date")}</th>
                <th>{t("End Date")}</th>
                <th>{t("Description")}</th>
                <th style={{width: 50}}>{t("")}</th>
              </tr>
            </thead>
            <tbody>
              {formik?.values?.workExperiences?.map((item: any, index: number) => {
                return (
                  <tr key={`${item?.id}`}>
                    <td
                      className="my-handle"
                      style={{
                        paddingRight: "10px",
                        paddingLeft: "5px",
                        paddingTop: "10px",
                        paddingBottom: "5px",
                        verticalAlign: "top",
                        width: "50px",
                      }}
                    >
                      {index + 1}
                      {/* <i className="ri-menu-line"></i> */}
                    </td>
                    <td
                      style={{
                        paddingRight: "10px",
                        paddingTop: "5px",
                        paddingBottom: "5px",
                        verticalAlign: "top",
                        width: "220px",
                      }}
                    >
                      <Input
                        name={`workExperiences.${index}.workplace`}
                        type="text"
                        className="form-control"
                        placeholder={t("Workplace")}
                        value={item?.workplace || ""}
                        onChange={(event: any) => {
                          console.log(event?.target?.value)
                          formik.setFieldValue(
                            `workExperiences.${index}.workplace`,
                            event?.target?.value
                          );
                        }}
                      />
                      {formik.touched.workExperiences?.[index]?.workplace &&
                      formik.errors.workExperiences &&
                      (formik.errors.workExperiences[index] as FormikErrors<any>)
                        ?.workplace ? (
                        <small className="text-danger mt-2">
                          {(formik.errors.workExperiences[index] as any)?.workplace}
                        </small>
                      ) : null}
                    </td>
                    <td
                      style={{
                        paddingRight: "10px",
                        paddingTop: "5px",
                        paddingBottom: "5px",
                        verticalAlign: "top",
                      }}
                    >
                      <Input
                        name={`workExperiences.${index}.position`}
                        type="text"
                        className="form-control"
                        placeholder={t("Position")}
                        value={item?.position || ""}
                        onChange={(event: any) => {
                          formik.setFieldValue(
                            `workExperiences.${index}.position`,
                            event?.target?.value
                          );
                        }}
                      />
                      {formik.touched.workExperiences?.[index]?.position &&
                      formik.errors.workExperiences &&
                      (formik.errors.workExperiences[index] as FormikErrors<any>)
                        ?.position ? (
                        <small className="text-danger mt-2">
                          {(formik.errors.workExperiences[index] as any)?.position}
                        </small>
                      ) : null}
                    </td>
                    <td
                      style={{
                        paddingRight: "10px",
                        paddingTop: "5px",
                        paddingBottom: "5px",
                        verticalAlign: "top",
                        width: "180px",
                      }}
                    >
                      <DatePicker
                        name={`workExperiences.${index}.startDate`}
                        className="form-control w-100"
                        selected={item?.startDate}
                        placeholderText={t("Start Date")}
                        onChange={(date: any) => {
                          formik.setFieldValue(
                            `workExperiences.${index}.startDate`,
                            date
                          );
                        }}
                        dateFormat="yyyy-MM-dd"
                        isClearable={true}
                      />
                      {formik.touched.workExperiences?.[index]?.startDate &&
                      formik.errors.workExperiences &&
                      (formik.errors.workExperiences[index] as FormikErrors<any>)
                        ?.startDate ? (
                        <small className="text-danger mt-2">
                          {(formik.errors.workExperiences[index] as any)?.startDate}
                        </small>
                      ) : null}
                    </td>
                    <td
                      style={{
                        paddingRight: "10px",
                        paddingTop: "5px",
                        paddingBottom: "5px",
                        verticalAlign: "top",
                        width: "180px",
                      }}
                    >
                      <DatePicker
                        name={`workExperiences.${index}.endDate`}
                        className="form-control w-100"
                        selected={item?.endDate}
                        placeholderText={t("End Date")}
                        onChange={(date: any) => {
                          formik.setFieldValue(
                            `workExperiences.${index}.endDate`,
                            date
                          );
                        }}
                        dateFormat="yyyy-MM-dd"
                        isClearable={true}
                      />
                      {formik.touched.workExperiences?.[index]?.endDate &&
                      formik.errors.workExperiences &&
                      (formik.errors.workExperiences[index] as FormikErrors<any>)
                        ?.endDate ? (
                        <small className="text-danger mt-2">
                          {(formik.errors.workExperiences[index] as any)?.endDate}
                        </small>
                      ) : null}
                    </td>
                    <td
                      style={{
                        paddingRight: "10px",
                        paddingTop: "5px",
                        paddingBottom: "5px",
                        verticalAlign: "top",
                      }}
                    >
                      <textarea
                        className="form-control"
                        name={`workExperiences.${index}.description`}
                        maxLength={1000}
                        value={item?.description}
                        placeholder={`${t("Description")}`}
                        onChange={(event) => {
                          formik.setFieldValue(
                            `workExperiences.${index}.description`,
                            event?.target?.value
                          );
                        }}
                        style={{ height: 60 }}
                      />
                      {formik.touched.workExperiences?.[index]?.description &&
                      formik.errors.workExperiences &&
                      (formik.errors.workExperiences[index] as FormikErrors<any>)
                        ?.description ? (
                        <small className="text-danger mt-2">
                          {(formik.errors.workExperiences[index] as any)?.description}
                        </small>
                      ) : null}
                    </td>
                    <td>
                      <div
                        className="d-flex"
                        style={{ justifyContent: "center", width: 50 }}
                      >
                        <div>
                          {
                            <div
                              className="text-danger cursor-pointer"
                              onClick={() => {
                                setIsOpenConfirm(true);
                                setIndexDelete(index);
                              }}
                            >
                              <i className="ri-delete-bin-3-fill align-bottom"></i>
                            </div>
                          }
                        </div>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </Col>

        {formik.touched?.workExperiences && formik.errors?.workExperiences ? (
          <small className="text-danger mt-2">
            {typeof formik.errors?.workExperiences === "string" &&
              formik.errors?.workExperiences}
          </small>
        ) : null}

        <Col lg={12} className="mb-2">
          <div
            className="text-primary text-center cursor-pointer mt-3 d-flex align-items-center justify-content-center gap-2"
            style={{ fontSize: 30, background: "#0bcee91c" }}
            onClick={handleAddItem}
          >
            + <span style={{ fontSize: 14 }}>{t("Add Experience")}</span>
          </div>
        </Col>
      </>

      <ModalConfirm
        header={t("Delete this workExperiences")}
        isOpen={isOpenConfirm}
        isLoading={isConfirmLoading}
        onClose={onCloseConfirmClick}
        onConfirm={handleActionDelete}
      />
    </React.Fragment>
  );
};

export default TalentExperienceArray;
